import axios from 'axios';
import { API_BASE_URL } from '../config/api';

// Get or create session ID
function getSessionId() {
  const STORAGE_KEY = 'visitor_session_id';
  const SESSION_EXPIRY = 30 * 60 * 1000; // 30 minutes
  
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    const { sessionId, timestamp } = JSON.parse(stored);
    // Check if session is still valid (not expired)
    if (Date.now() - timestamp < SESSION_EXPIRY) {
      return sessionId;
    }
  }
  
  // Generate new session ID
  const newSessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    sessionId: newSessionId,
    timestamp: Date.now()
  }));
  
  return newSessionId;
}

// Check if user is admin
async function isAdmin() {
  const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
  if (!token) {
    return false;
  }
  
  try {
    const response = await axios.get(`${API_BASE_URL}/auth/verify`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.success === true;
  } catch (err) {
    return false;
  }
}

// Track visitor activity with event type and metadata
export async function trackEvent(eventType, metadata = {}) {
  try {
    // Skip if admin
    const userIsAdmin = await isAdmin();
    if (userIsAdmin) {
      console.log('[Tracking] Skipping - user is admin');
      return;
    }

    const sessionId = getSessionId();
    
    console.log('[Tracking] Sending event:', eventType, metadata);
    
    const response = await axios.post(`${API_BASE_URL}/visitor/activity`, {
      sessionId,
      path: window.location.pathname + window.location.search,
      referrer: document.referrer || null,
      eventType, // 'page_view', 'tag_click', 'category_click', 'product_click', 'add_to_cart', 'cart_view', 'format_click'
      metadata
    });
    
    console.log('[Visitor Tracking] Event tracked successfully:', eventType, metadata, response.data);
  } catch (error) {
    // Log error but don't break user experience
    console.error('[Visitor Tracking] Error tracking event:', eventType, error.message, error.response?.data);
  }
}

// Convenience functions for specific events
export const trackTagClick = (tag) => trackEvent('tag_click', { tag });
export const trackCategoryClick = (category) => trackEvent('category_click', { category });
export const trackProductClick = (designId, designTitle) => trackEvent('product_click', { designId, designTitle });
export const trackAddToCart = async (designId, designTitle, formatId, formatName, productType, price, quantity) => {
  console.log('[Tracking] Add to cart called:', { designId, designTitle, formatId, formatName, productType, price, quantity });
  try {
    await trackEvent('add_to_cart', { designId, designTitle, formatId, formatName, productType, price, quantity });
    console.log('[Tracking] Add to cart tracking sent successfully');
  } catch (error) {
    console.error('[Tracking] Add to cart tracking failed:', error);
  }
};
export const trackCartView = () => trackEvent('cart_view');
export const trackFormatClick = (formatId, formatName, productType) => 
  trackEvent('format_click', { formatId, formatName, productType });
export const trackDesignLove = (designId, designTitle) => 
  trackEvent('design_love', { designId, designTitle });

